import { useMemo, useState } from 'react';
export function useTabs(children, initialTabIndex) {
    if (initialTabIndex === void 0) { initialTabIndex = 0; }
    var _a = useState(initialTabIndex), selectedTab = _a[0], setSelectedTab = _a[1];
    var handlers = useMemo(function () { return children.map(function (_, i) { return function () { return setSelectedTab(i); }; }); }, [children.length]);
    return [selectedTab, handlers];
}
//# sourceMappingURL=useTabs.js.map